<h2 mat-dialog-title>Change Password</h2>
<mat-dialog-content>
    <form [formGroup]="passwordForm">
        <div class="form-container">
            <div class="form-section">
                <div class="row m-t-5">
                    <div class="col-6 col-sm-12 ">
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-label>New Password</mat-label>
                            <input matInput type="password" formControlName="password"
                                (input)="onPasswordInput($event)">
                            <mat-progress-bar *ngIf="passwordForm.get('password')?.value" mode="determinate"
                                [value]="passwordStrength"
                                [class.weak]="passwordForm.get('password')?.errors?.['passwordStrength']">
                            </mat-progress-bar>
                            <mat-error
                                *ngIf="passwordForm.get('password')?.touched && passwordForm.get('password')?.errors?.['passwordStrength']">
                                {{ passwordForm.get('password')?.errors?.['passwordStrength'] }}
                            </mat-error>
                        </mat-form-field>
                        <app-password-strength [password]="passValue"></app-password-strength>
                    </div>
                    <div class="col-6 col-sm-12">
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-label>Confirm Password</mat-label>
                            <input matInput type="password" formControlName="confirmPassword">
                            <mat-error *ngIf="passwordForm.get('confirmPassword')?.hasError('passwordMismatch')">
                                Passwords do not match
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button (click)="onSubmit()" mat-raised-button color="primary"><mat-icon>save</mat-icon>Save Changes</button>
</mat-dialog-actions>